<template>
  <!-- 线形音频 -->
  <div class="audioOff">
    <audio ref="player" :src="audioHttp" @timeupdate="updateTime"></audio>
    <div class="isPlayImg">
      <div class="left">
        <div style="margin-top:5px;">
          <!--开始播放-->
          <img v-if="!isPlay" @click="audioState" src="@images/play.svg">
          <!--暂停-结束播放-->
          <img v-if="isPlay" @click="audioState" src="@images/stop.svg">
        </div>
        <div class="hasTime ml-5">
          <span class="right-timer">{{hasTime}}</span>
        </div>
      </div>

      <div class="block">
        <el-slider ref="myRange" v-model="rangeValue" @change="onChange" :show-tooltip="false"></el-slider>
      </div>

      <div class="right">
        <div class="duration tr">
          <span class="right-timer" v-show="totalTime !== 'NaN:NaN'">{{totalTime}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    audioHttp: {
      type: String,
      default: ''
    },
    audioStatus: {
      type: String,
      default: ''
    },
    itemId: {
      type: String,
      default: ''
    },
    itemTime: {
      type: Number
    }
  },
  // computed: {
  //   audioHttpActive() {
  //     return this.$store.state.audioHttpActive
  //   }
  // },
  watch: {
    // 监听音频父组件状态
    audioStatus(val) {
      console.log(val)
      this.isStatus = val
      if (this.isStatus === 'stop') {
        this.isPlay = false
        this.$refs.player.load()
        this.rangeValue = 0
        this.hasTime = '00:00'
      }
    }
  },
  data() {
    return {
      rangeValue: 0,
      isDraging: false, // 是否在拖动进度条
      hasTime: '00:00', // 已播放时间
      totalTime: '00:00', // 总播放时间
      isPlay: false, // 播放暂停按钮
      isStatus: this.audioStatus
    }
  },
  methods: {
    // 获取音频正在播放的时间
    updateTime() {
      const music = this.$refs.player // 音频所在对象
      const musicTime = music.duration // 获得音频时长
      const stopTime = music.currentTime // 获得已播放的音频时长
      this.hasTime = this._parseTime(stopTime)

      if (!this.isDraging) {
        this.rangeValue = (stopTime / musicTime) * 100
      }

      if (this.hasTime === this.totalTime) {
        this.isPlay = false
      }
    },
    // 点击播放暂停按钮时间
    audioState() {
      this.isPlay = !this.isPlay // 更改播放暂停按钮状态
      const music = this.$refs.player // 音频所在对象

      if (this.isPlay) {
        if (this.hasTime === this.totalTime) {
          this.rangeValue = 0
        }
        music.play() // 播放音乐
      } else {
        music.pause() // 暂停音乐
      }
    },
    // 转化成具体的时间格式
    _parseTime(sec) {
      let minutes = parseInt(sec / 60)
      let seconds = parseInt(sec - 60 * minutes)
      return (
        (minutes < 10 ? '0' + minutes : minutes) +
        ':' +
        (seconds < 10 ? '0' + seconds : seconds)
      )
    },
    onChange() {
      const music = this.$refs.player // 音频所在对象
      this.isDraging = true
      music.currentTime = music.duration * (this.rangeValue / 100)
    }
  },
  mounted() {
    const music = this.$refs.player // 音频所在对象
    // // 获取视频音频总时长
    music.ondurationchange = () => {
      const musicTime = music.duration // 获得音频时长
      this.totalTime = this._parseTime(musicTime)
    }
  }
}
</script>

<style lang="scss" scoped>
.audioOff {
  padding: 2px 10px;
  border: 1px solid #ebedf2;
  border-radius: 22px;
  background: #ebedf2;
  width: 100%;
  min-width: 250px;
  height: 32px;
  position: relative;
  padding: 0 70px 0 75px;
  box-sizing: border-box;
  // padding: 0
  // width: 209px;
  display: inline-block;
  .left {
    position: absolute;
    left: 10px;
    top: 0;
    display: flex;
  }
  .right {
    position: absolute;
    right: 10px;
    top: 0;
  }
  .isPlayImg {
    width: 100%;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    img {
      width: 18px;
      height: 18px;
      vertical-align: middle;
      cursor: pointer;
    }
    .duration,
    .hasTime {
      // width: 70px;
      font-size: 12px;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 32px;
    }
  }
}
.block {
  width: 100%;
  height: 100%;
  padding-top: 15px;
}
/deep/.el-slider__runway {
  // width: 100%;
  // width: 85px;
  height: 2px;
  margin: 0 10px;
  background-color: #ffff;
  .el-slider__button {
    height: 8px;
    width: 8px;
    border: 2px solid #fff;
  }
  .el-slider__bar {
    height: 2px;
  }
  .el-slider__button-wrapper {
    top: -17px;
  }
}
</style>